import * as Yup from 'yup';
import { PqrAttachment } from '../../../../../shared/types/modules/pqr';

export const initialValues: PqrAttachment = {
    attachments: [],
    observation: '',
};

export const validationSchema = Yup.object({
    observation: Yup.string().required('La observación es obligatoria'),
    attachments: Yup.array()
        .min(1, 'Debes adjuntar al menos un archivo')
        .required('Los archivos adjuntos son obligatorios'),
});
